import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Typography,
  IconButton,
  TextField,
  makeStyles,
} from "@material-ui/core";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useManualQuery } from "graphql-hooks";

import { GET_TERM_TEAM_MEMBER_QUERY } from "../../graphQL/team_term_member_qry";

import { project_url } from "../../constants/Data";

const useStyles = makeStyles((theme) => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
  selectStyle: {
    minWidth: 200,
    height: 35,
    paddingRight: 16,
    marginBottom: 25,
    "& .MuiOutlinedInput-input": {
      textAlign: "left",
    },
  },
}));

export default function StaffNoteInfoDialog({
  closeDialog,
  fullName,
  userUuid,
  termUuid,
  termName,
  termTeams,
  termRoles,
  teamTermMemberIds
}) {
  console.log("StaffNoteInfoDialog:",teamTermMemberIds);
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [note, setNote] = useState(" ");
  const [noteUpdateDate, setNoteUpdateDate] = useState(" ");
  const [noteUpdateBy, setNoteUpdateBy] = useState(" ");
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set time to 00:00:00 to compare only the date part
    
  const [getMemberTermMemberQuery] = useManualQuery(GET_TERM_TEAM_MEMBER_QUERY);

  const handleChangeValue = async (event) => {
    console.log("handleChangeValue:", event.target.value);
       const {
        loading: loadingData,
        error: errorData,
        data: dataMember,
      } = await getMemberTermMemberQuery({
        variables: {
          teamTermMemberId: parseInt(event.target.value),
        },
      });

      if (!loadingData && dataMember) {
        let teamTermMember = dataMember.getTermTeamMember;
        setNote(teamTermMember.note);
        if (teamTermMember.noteUpdateDate)
            setNoteUpdateDate(dayFormat(teamTermMember.noteUpdateDate));
        else
            setNoteUpdateDate("-");
        if(teamTermMember.noteUpdateBy)
            setNoteUpdateBy(dataMember.getTermTeamMember.noteUpdateBy.split(":")[1]);
        else
            setNoteUpdateBy("-");
      }
      if (errorData) {
          console.log(errorData);
          if (errorData.graphQLErrors[0].message === "Signature has expired")
            navigate(`${project_url}/signin/?next=${pathname}`);
      }
  };
  
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };
  const dayFormat = day => {
    let newFormat = "-";
    if (day) {
      const dayDate = new Date(day);
      const dayFormat = formatter.formatToParts(dayDate);
      newFormat =
        dayFormat.find(a => a.type === "month").value +
        "/" +
        dayFormat.find(a => a.type === "day").value +
        "/" +
        dayFormat.find(a => a.type === "year").value;
    }
    return newFormat;
  };
  
  useEffect(() => {
    handleChangeValue({ target: { value: teamTermMemberIds[0] } });
  }, [termTeams, teamTermMemberIds]);
  
  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  
  function CustomNoRowsOverlay() {
    return (    
      <Box sx={{ mt: 2 }}>There is no staff's note</Box>
    );
  }
  
  return (
    <div>
      <Dialog disablePortal
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "1100px",
              height: "400px"
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box mt={1} ml={1}>
            Staff Note
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
            <Typography variant="h3" style={{ fontSize: 16, textAlign: 'left', marginBottom: 5 }}>
              <b>Staff:</b> {fullName}
            </Typography>
            <Typography variant="h3" style={{ fontSize: 16, textAlign: 'left', marginBottom: 5 }}>
              <b>Term:</b> {termName}
            </Typography>
            <Typography variant="h3" style={{ fontSize: 16, textAlign: 'left' }}>
              <b>Team: </b>
               {termTeams.length === 1 ? (
                <>
                  {termTeams[0]} / {termRoles[0]}
                </>
                ) : (
              <Select
                className={classes.selectStyle}
                defaultValue={teamTermMemberIds[0]}
                margin="normal"
                onChange={handleChangeValue}
              >
                {termTeams.map((team, index) => (
                  <MenuItem key={index} value={teamTermMemberIds[index]}>
                    {team} / {termRoles[index]}
                  </MenuItem>
                ))}
              </Select>
              )}
            </Typography>
            <TextField
              className={classes.textFieldStyle}
              fullWidth
              label="Staff Note"
              disabled
              variant="outlined"
              value={note}
              multiline
              rows={3}
            />
             <Typography variant="h4" style={{ fontSize: 16, textAlign: 'left' }}>
              <b>Last Updated: </b>{ noteUpdateDate } - { noteUpdateBy }
            </Typography>             
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                onClick={handleClose}
              >
                OK
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}